import { Fragment } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { __PERSON_API_URL__ } from 'shell/constants/environment';
import FormReleasedService, {
  CertificateForm,
} from 'front-office/components/released-services/form';
import { HttpResponse } from 'shell/models/http-response';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonCertificateCrumbs } from '../constants';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { noop } from 'shell/utils/noop';
import { HistoricalReleasedService } from 'shell/models/historical-released-services';
import { transformCertificateHistorical } from 'front-office/components/released-services/utils/transform-certificate-historical';

const ReleasedServiceHistoricalDetailPage = (): React.ReactElement => {
  const params = useParams();

  const [queryParams] = useSearchParams();

  const navigate = useNavigate();

  const numeroCarta = queryParams.get('numeroCarta') || '';

  const [certificate] = useHttpFetch<HttpResponse<HistoricalReleasedService>, CertificateForm>(
    `${__PERSON_API_URL__}/storico-servizi-rilasciati/dettaglio`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'POST',
        loading: true,
        data: {
          annoServizio: params.idAnno,
          numeroCartaIdentita: numeroCarta || undefined,
          numeroServizio: params.numeroServizio,
          tipoRegistro: params.tipoRegistro,
          matricola: params.matricola,
        },
      },
      transformer: transformCertificateHistorical,
    }
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonCertificateCrumbs, { name: 'Dettaglio Certificato' }]} />
      {certificate.isLoading || !certificate.data ? null : (
        <FormReleasedService
          title={'Dettaglio Servizio rilasciato'}
          onOk={noop}
          onGoBack={() => {
            navigate('/sportello/controllo-di-cassa');
          }}
          disabled
          initialValues={certificate.data as CertificateForm}
        />
      )}
    </Fragment>
  );
};

ReleasedServiceHistoricalDetailPage.displayName =
  'Released Service Detail historical page component';

export default ReleasedServiceHistoricalDetailPage;
